export default __webpack_public_path__ + "static/media/rise.bcf8f2d2.svg";